module.exports = __webpack_public_path__ + "static/img/13.bd7ef57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/sp/13.png
// module id = VfIO
// module chunks = 0